<template>
  <div class="container-fluid">
    <div class="row mt-5">
      <div class="col-12">
        <a v-if="!Addmode" @click="Getnumber()"><h4 class="text-primary fas fa-plus"></h4></a>
        <a v-if="Addmode" @click="Addmode = false"><h4 class="text-danger fas fa-times"></h4></a>
      </div>
    </div>
    <div v-if="Addmode" class="row" id="AddAdress">
      <!-- <div class="col-lg-3 col-12 p-2">
          <small id="LblTarafname">نوع </small>
          <SearchableCombo
            :edit="false"
            :grp="36"
            :code="null"
            @ResultCombo="GetResulttblComboGrp36Noe"
            :rownumintable="3"
            :defaultvalue="DataAxiosAdd.ArryfildValue.tblComboGrp36Noe"
            :action="'TblCrmCombo/GetComboById'"
            :method="'POST'"
            :idinput="'tblComboGrp36Noe'"
            :keyItem="'tblComboGrp36Noe'"
            :disabled="false"
            :ClassProps="'required'"
          >
          </SearchableCombo>
        </div> -->
      <div class="col-lg-3 col-12 p-2">
        <small>شماره نامه</small>
        <input disabled type="text" v-model="DataAxiosAdd.ArryfildValue.Number" class="form-control text-left required" />
      </div>
      <div class="col-lg-3 col-12 p-2">
        <small id="LblPersonle">پرسنل مخاطب </small>
        <SearchableCombo
          :edit="false"
          :grp="master.tblCustomerId"
          :code="null"
          @ResultCombo="GetResultPersonel"
          :rownumintable="3"
          :defaultvalue="DataAxiosAdd.ArryfildValue.tblPersonelId"
          :action="'TblCrmCombo/GetPersonelCombo'"
          :method="'POST'"
          :idinput="'Personel'"
          :keyItem="'Personel'"
          :disabled="false"
          :ClassProps="'required'"
        >
        </SearchableCombo>
      </div>

      <div class="col-lg-3 col-12 p-2">
        <small id="lblAndicatorDate"> تاریخ</small>
        <date-picker color="dimgray" input-class="required form-control" id="AndicatorDate" v-model="DataAxiosAdd.ArryfildValue.AndicatorDate" clearable :editable="true" placeholder=" تاریخ "></date-picker>
      </div>
      <div class="col-lg-6 col-12 p-2">
        <small id="LblSubject"> موضوع</small>
        <textarea id="Subject" class="form-control required" v-model="DataAxiosAdd.ArryfildValue.Subject"></textarea>
      </div>

      <div class="col-md-5 border Rounded p-1 col-12">
        <small>فایل</small>
        <Uploader @upload="upload"></Uploader>
      </div>
      <div class="col-md-8 col-12"></div>

      <div class="col-md-4 col-12">
        <button @click="Insert" class="btn mt-5 w-100 btn-success">ثبت نامه</button>
      </div>
    </div>
    <div v-else>
      <BnpGrid :hasRowNum="true" v-if="render" :propsColumn="Columns" :propsRows="ListArchive" :action="true">
        <template slot="action-slot" slot-scope="props" v-if="props.props.Filepath.indexOf('.') > 0 || props.props.FileName.indexOf('.') > 0">
          <a v-if="props.props.Filepath.indexOf('.') > 0 || props.props.FileName.indexOf('.') > 0" @click="Download(props.props)" class="mx-1"><i class="fad fa-download"></i></a>
          <a v-if="candelete(props.props)" @click="DeleteFile(props.props)" class="mx-1"><i class="fad fa-times text-danger"></i></a>
        </template>
      </BnpGrid>
    </div>
  </div>
</template>
<script>
import Uploader from '@/components/Uploader/Uploader.vue'
import datePicker from 'vue-persian-datetime-picker'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'

export default {
  data() {
    return {
      Addmode: false,
      DataAxiosAdd: {
        Action: 'Andicator/AddAndicator',
        Method: 'Post',
        ArryfildValue: {},
      },
      NewAndicator: {
        Id: 55,
        tblPersonelId: 0,
        tblComboGrp36Noe: 0,
        tblCustomerId: this.master.CustomerId,
        FileName: '',
        Number: '',
        Subject: '',
        AndicatorDate: this.$store.state.JalaliDate,
        Filepath: 'ArchiveFiles/' + this.master.Number,
        DateTimeInsert: '',
        DateTimeLastEdit: '',
        tblUserGrpIdLastEdit: null,
        tblUserGrpInsert: this.$session.get('UserInfo').tblUserGrpId,
        file: null,
        parentId: this.master.Id,
      },
      ListArchive: [],
      render: true,
      Columns: [
        { id: 2416, name: 'Number', visibility: true, label: 'شماره نامه' },
        { id: 2417, name: 'Subject', visibility: true, label: 'موضوع' },
        { id: 2465, name: 'AndicatorDate', visibility: true, label: 'تاریخ ' },
      ],
    }
  },
  props: ['master'],
  mounted() {
    this.getList()
    console.log(this.master)
  },
  methods: {
    getList() {
      var DataAxiosGEt = { Action: 'Andicator/GetArchived', Method: 'POST', ArryfildValue: { Id: Number(this.master.Id) } }
      // console.log(DataAxiosGEt)
      this.$PostData(DataAxiosGEt).then((result) => {
        this.ListArchive = result.data
        this.render = false
        this.$nextTick(() => {
          this.render = true
        })
      })
    },
    Getnumber() {
      this.Addmode = true
      // console.log(this.master)
      this.DataAxiosAdd.ArryfildValue = JSON.parse(JSON.stringify(this.NewAndicator))
      var DataAxiosGEt = { Action: 'Andicator/GetArchiveNumber', Method: 'POST', ArryfildValue: { str: this.master.Number } }
      this,
        this.$PostData(DataAxiosGEt).then((result) => {
          this.DataAxiosAdd.ArryfildValue.Number = result.andicatorNumber
          // console.log(this.DataAxiosAdd.ArryfildValue)
        })
    },
    GetResultPersonel(data) {
      if (data.id != null) {
        this.DataAxiosAdd.ArryfildValue.tblPersonelId = data.id
      }
    },
    upload(data) {
      this.DataAxiosAdd.ArryfildValue.file = data
    },
    Insert() {
      var formData = new FormData()
      console.warn(this.master)
      formData.append('Number', this.DataAxiosAdd.ArryfildValue.Number)
      formData.append('FileName', this.DataAxiosAdd.ArryfildValue.FileName)
      formData.append('tblCustomerId', this.master.tblCustomerId)
      formData.append('tblComboGrp36Noe', this.master.tblComboGrp36Noe)
      formData.append('tblPersonelId', this.DataAxiosAdd.ArryfildValue.tblPersonelId)
      formData.append('Id', this.DataAxiosAdd.ArryfildValue.Id)
      formData.append('Subject', this.DataAxiosAdd.ArryfildValue.Subject)
      formData.append('AndicatorDate', this.DataAxiosAdd.ArryfildValue.AndicatorDate)
      formData.append('Filepath', 'AndicatorFile' + '\\' + this.master.Codebazaryabi + '\\' + '//Archive')
      formData.append('DateTimeInsert', this.DataAxiosAdd.ArryfildValue.DateTimeInsert)
      formData.append('DateTimeLastEdit', this.DataAxiosAdd.ArryfildValue.DateTimeLastEdit)
      formData.append('tblUserGrpIdLastEdit', this.DataAxiosAdd.ArryfildValue.tblUserGrpIdLastEdit)
      formData.append('tblUserGrpInsert', this.DataAxiosAdd.ArryfildValue.tblUserGrpInsert)
      formData.append('file', this.DataAxiosAdd.ArryfildValue.file)
      formData.append('parentId', this.master.Id)
      this.DataAxiosAdd.ArryfildValue = formData
      this.$PostFormData(this.DataAxiosAdd)
        .then((result) => {
          if (result.status == 'success') {
            this.Addmode = false
            this.$mySweetDefaultTost('عملیات موفق', 'نامه جدید با موفقیت ثبت شد', 'success', 2000)
            this.$emit('Inserted', {
              done: 'OK',
              activeTab: 6,
            })
          } else {
            this.$mySweetDefaultTost('عملیات ناموفق', 'مشکلی در ثبت بوجود امده است', 'warning', 2000)
          }
        })
        .catch((error) => {
          this.$mySweetDefaultTost('عملیات ناموفق', 'خطای سیستم', 'error', 2000)
          console.error(error)
        })
    },
    Download(data) {
      var DataAxios = {
        Action: 'Download',
        Method: 'Post',
        ArryfildValue: {
          FilePath: data.Filepath,
          FileName: data.FileName,
          Number: data.Number,
        },
      }
      this.$PostData(DataAxios).then((response) => {
        var fileLink = document.createElement('a')
        fileLink.href = 'data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,' + response.data.fileContents
        fileLink.setAttribute('download', response.data.fileDownloadName)
        document.body.appendChild(fileLink)
        fileLink.click()
      })
    },
    DeleteFile(data) {
      console.log(data)
      this.$emit('Delete', {
        data: data,
      })
    },
    candelete(data) {
      return ((data.Filepath.indexOf('.') > 0 || data.FileName.indexOf('.') > 0) && this.$session.get('UserInfo').tblUserGrpId && data.DateTimeInsert.substring(0, 10) == this.$store.state.JalaliDate) || this.$session.get('UserInfo').tblUserGrpId == 1
    },
  },
  components: { Uploader, datePicker, SearchableCombo, BnpGrid },
}
</script>
